import BaseResource from './index'

export default class SchoolResource extends BaseResource {
    static endpoint = '/schools'

    isElite() {
        return this.attributes.priority > 80
    }

    toString() {
        return this.attributes.name
    }
}
